module.exports = __webpack_public_path__ + "img/shaixuanxuanzhong.d14299b6.svg";